export const MapError = {
  MAP_NOT_FOUND: 'MapNotFound',
  MAP_UNKNOWN_ERROR: 'MapUnknownError',
  MAP_LOAD_ERROR: 'MapLoadError'
}
